const IResourceCatalogService = require('../IResourceCatalogService');
const ResourceCatalogUtil = require('./common/ResourceCatalogUtil');
const Util = require('./common/Util');
const Extend = require('../../../base/util/Extend');
/**
 * @classdesc 资源目录服务
 * @alias G.servicev2.ResourceQueryServiceImpl
 * @augments G.service.IResourceCatalogService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class ResourceCatalogServiceImpl extends IResourceCatalogService {
    constructor(opts) {
        super(opts);
        //
        this.treeSet = {};
    }

    /**
     * 注册自定义树
     * @param {Strign} id 
     * @param {Array} data 
     */
    registCustomTree(id, data) {
        this.treeSet[id] = data;
    }

    /**
     * 取消注册自定义树
     * @param {Strign} id 
     */
    unregistCustomTree(id) {
        this.treeSet[id] = null;
        delete this.treeSet[id];
    }

    /**
     * @inheritdoc
     */
    stat(opts) {
        return new Promise(async(resolve, reject) => {
            let result = await ResourceCatalogUtil.statTree({
                treeId: opts.treeId,
                nodeId: opts.nodeId,
                treeSet: this.treeSet,
                url: this.opts.url,
                httpRequest: this.opts.httpRequest
            });
            resolve(result);
        });
    }

}
module.exports = ResourceCatalogServiceImpl;